import { invert } from "@p-ban/common/src/utils/ObjectUtils"

import ESTIMATE_CONSTANT from "../../constant/estimateConstant"
import FIELD_NAMES from "../../constant/fieldNames"
import type { EstimateFieldOf } from "../estimateFields/estimateField"
import estimateField from "../estimateFields/estimateField"

const getConstantByValue = (field: EstimateFieldOf<"radio">, value: string) => {
  const constants = getConstantsByField(field)
  const constant = Object.values(constants).find((nameValue) => nameValue.value === value)
  if (constant) {
    return constant
  }

  throw new Error(`指定された値が定数に存在しません。field: ${field} value: ${value}`)
}

export default getConstantByValue

const getConstantsByField = (
  field: EstimateFieldOf<"radio">
): {
  readonly [displayName: string]: {
    readonly name: string
    readonly value: string
  }
} => {
  switch (field) {
    case estimateField.rfContactPortion1.key:
    case estimateField.rfContactPortion2.key:
      return ESTIMATE_CONSTANT.仕上り厚み指定
    case estimateField.rfContactPortionBonding1.key:
    case estimateField.rfContactPortionBonding2.key:
      return ESTIMATE_CONSTANT.接着面
    case estimateField.reinForcement1.key:
    case estimateField.reinForcement2.key:
      return ESTIMATE_CONSTANT.厚み指定
    case estimateField.reinForcementBonding1.key:
    case estimateField.reinForcementBonding2.key:
      return ESTIMATE_CONSTANT.接着面
    default:
      const displayName = invert(FIELD_NAMES)[field]
      return ESTIMATE_CONSTANT[displayName]
  }
}
